module.exports = __webpack_public_path__ + "static/top_contact_bg-266af6707f64e61936b2b0734fb890e0.png";